import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { CustomTable } from "./CustomTable";
import { ReactComponent as RefIcon } from "../../assets/candidates/ref.svg";
import styles from "./styles.module.scss";
import {
  getApprovedReferences,
  getReferences,
} from "../../api/candidate/candidate.class";
import { ReactComponent as AddIcon } from "../../assets/candidates/whiteAdd.svg";

const Reference = () => {
  const [reference, setReference] = useState(false);
  const [data, setData] = useState([]);
  const [updation, setUpdation] = useState(false);
  useEffect(() => {
    const tableData = async () => {
      try {
        // const response = await getApprovedReferences();
        const response = await getReferences();
        // console.log(response);
        setData(response?.data?.results?.data);
      } catch (e) {
        console.log(e);
      }
    };

    tableData();
  }, [updation]);
  return (
    <>
      <Box className={`d-flex mb-4 ${styles.parent}`}>
        <Box className={styles.button}>
          <Typography variant="h4" className="mb-0">
            References
          </Typography>
        </Box>
        <Box
          // sx={{ mt: "30px" }}
          className={`${styles.editicon} mx-4`}
          onClick={() => {
            setReference(true);
          }}
          style={{
            color: "#fff",
            fontFamily: "poppins-semi-bold",
            fontSize: "14px",
            alignItems: "center",
            display: "flex",
            background: "#00CFC5",
            border: "1px solid #00CFC5",
            borderRadius: "4px",
            padding: "6px 12px",
            cursor: "pointer",
          }}
        >
          <AddIcon /> <span style={{ padding: "5px" }}>Add</span>
        </Box>
      </Box>

      <CustomTable
        data={data}
        setReference={setReference}
        reference={reference}
        setUpdation={setUpdation}
      />
    </>
  );
};

export default Reference;
